import {createLazyFileRoute} from '@tanstack/react-router'

import StoreFront from '@/views/Stores/StoreFront'

export const Route = createLazyFileRoute('/stores/$storeId/')({
  component: StoreFront,
})
